import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4adj9wfm65: FaireBrandEntity = {
  token: "b_4adj9wfm65",
  type: "brand",
  name: "Glittering South",
  avatarUrl:
    "https://cdn.faire.com/fastly/e6262331a31ea589e5a0b8090f59085d4d560a89300f3dd355930b99b345f2db.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/de420245e65a503128c424166ef7ee26604943322a2e8913088c88c4d189d310.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e6262331a31ea589e5a0b8090f59085d4d560a89300f3dd355930b99b345f2db.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/de420245e65a503128c424166ef7ee26604943322a2e8913088c88c4d189d310.jpeg",
  location: "Thompsons Station, TN, USA",
  minimumOrderDollars: 139,
  rating: 4.7,
  reviewCount: 212,
  isInsider: true,
  description:
    "Glittering South is a family owned brand that specializes in custom made apparel.  Every shirt you receive from us has been printed by hand in our warehouse so you can be sure you are receiving top quality products.\n\nWe are able to offer many customized options including different colors, sizing and styles! Just ask and we can help all your t-shirt needs become a reality!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:46.670Z",
    importedBy: "entity-db-cli",
  },
};
